import { digitsAndLetters, makeRandomString, makeUniqueRandomName } from "@glide/support";
import { getFeatureSetting } from "./feature-settings";

let lastIndex = 0;

export function makeComponentID(nameExists?: (n: string) => boolean): string {
    if (getFeatureSetting("concurrentEditing")) {
        if (nameExists === undefined) {
            // This is about 30 bits, which makes collisions super unlikely.
            return makeRandomString(5, digitsAndLetters);
        } else {
            return makeUniqueRandomName(nameExists);
        }
    } else {
        lastIndex++;
        return `c${lastIndex}`;
    }
}
